<template>
  <qc-container title="调查问卷" show-return show-divider>
    <el-descriptions v-if="detail" :column="3" border >
      <el-descriptions-item label-class-name="w100" label="用户">
        <user-box :detail="detail"></user-box>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="编号">{{detail.code}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="完成时间">{{detail.createTime}}</el-descriptions-item>
    </el-descriptions>
  </qc-container>
  <qc-container v-if="detail" title="问卷详情" class="mt20">
      <div class="item-box" v-for="(item,index) in detail.itemList">
        <div class="title-box">
          <span class="index">{{index+1}}、</span>
          <span class="title">{{item.title}}</span>
        </div>
        <div class="content">{{item.content}}</div>
      </div>
      <div class="item-box">
        <div class="title-box">其他意见</div>
        <div class="content">{{detail.otherContent}}</div>
      </div>
    <return-box></return-box>
  </qc-container>
</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import UserBox from "@view/components/user-box.vue";
import ReturnBox from "@/components/home/return-box.vue";

export default {
  name: "questionnaire-detail",
  components: {ReturnBox, UserBox, QcContainer},
  data() {
    return {
      detail:null,
    }
  },
  mixins: [tableBase],
  methods: {},
  mounted() {
    this.simplePost("/api/mgr/business/content/question/answer/getDetail",{id:this.$route.query.id},result=>{
      this.detail = result.data;
    })
  }
}
</script>


<style lang="less" scoped>
.item-box{
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  .title-box{
    font-size: 16px;
    font-weight: bold;
    height: 30px;
  }
  .content{
    margin-left: 24px;
  }
}
</style>
